"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectScenarioTemplate = selectScenarioTemplate;
exports.selectTileOpeningType = selectTileOpeningType;
exports.selectIsCasinoScenarioType = selectIsCasinoScenarioType;
exports.selectIsSingleTileOpeningType = selectIsSingleTileOpeningType;
exports.selectGameTypeId = selectGameTypeId;
exports.selectIsExpressGame = selectIsExpressGame;
exports.selectIsSinglePlayLearn = selectIsSinglePlayLearn;
exports.selectIsSinglePlayChamp = selectIsSinglePlayChamp;
exports.selectScenarioTHasFrequency = selectScenarioTHasFrequency;
exports.selectScenarioTCanReplayMap = selectScenarioTCanReplayMap;
exports.selectScenarioTIsNeedTimer = selectScenarioTIsNeedTimer;
exports.selectGameTemplate = void 0;

var _constants = require("../constants");

var _tileOpeningType = require("../../../constants/tile-opening-type");

var _reselect = require("reselect");

var _gameType = require("../../../constants/game-type");

function selectModule(state) {
  return state[_constants.SCENARIO_MODULE_NAME];
}

function selectScenarioTemplate(state) {
  return selectModule(state).template;
} // TileOpeningTypeId


function selectTileOpeningType(state) {
  return selectScenarioTemplate(state).tileOpeningType;
}

function selectIsCasinoScenarioType(state) {
  return selectTileOpeningType(state) === _tileOpeningType.TILE_OPENING_TYPE.TYPE_CASINO;
}

function selectIsSingleTileOpeningType(state) {
  return selectTileOpeningType(state) === _tileOpeningType.TILE_OPENING_TYPE.TYPE_SINGLE_ANSWER;
} // GameTypeId


function selectGameTypeId(state) {
  return selectScenarioTemplate(state).gameType;
}

function selectIsExpressGame(state) {
  return selectGameTypeId(state) === _gameType.GAME_TYPE.EXPRESS;
}

function selectIsSinglePlayLearn(state) {
  return selectGameTypeId(state) === _gameType.GAME_TYPE.SINGLE_PLAY_LEARN;
}

function selectIsSinglePlayChamp(state) {
  return selectGameTypeId(state) === _gameType.GAME_TYPE.SINGLE_PLAY_CHAMP;
} // Template options


function selectScenarioTHasFrequency(state) {
  return selectScenarioTemplate(state).hasFrequency;
}

function selectScenarioTCanReplayMap(state) {
  return selectScenarioTemplate(state).canReplayMap;
}

function selectScenarioTIsNeedTimer(state) {
  return selectScenarioTemplate(state).hasStepTimers;
}

var selectGameTemplate = (0, _reselect.createSelector)(selectGameTypeId, selectTileOpeningType, selectScenarioTHasFrequency, function (gameType, tileOpeningType, withFrequency) {
  return {
    gameType: gameType,
    tileOpeningType: tileOpeningType,
    withFrequency: withFrequency
  };
});
exports.selectGameTemplate = selectGameTemplate;